import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "../../../../components/account/ui";
import { UsageCard } from "../../../../components/UsagePanel";

export const Route = createFileRoute("/_app/account/konsoll/forbruk")({
	component: () => (
		<>
			<PageHeader title="Forbruk" description="API-kall i inneværende periode" />
			<UsageCard />
		</>
	),
});
